import { Controller } from "@hotwired/stimulus"

// Expande/recolhe o alvo `content` alternando a altura entre `collapsed-height`
// e `auto`, trocando o texto do gatilho entre `label-expand`/`label-collapse`.
export default class extends Controller {
  static targets = ["content"]
  static values = {
    collapsedHeight: { type: String, default: "200px" },
    labelExpand: { type: String, default: "Mostrar tudo" },
    labelCollapse: { type: String, default: "Ocultar" }
  }

  toggle(event) {
    if (event) event.preventDefault()
    const expanded = this.contentTarget.style.height === "auto"
    this.contentTarget.style.height = expanded ? this.collapsedHeightValue : "auto"
    if (event && event.currentTarget) {
      event.currentTarget.textContent = expanded ? this.labelExpandValue : this.labelCollapseValue
    }
  }
}
